import React from 'react';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import SectionWrapper from '../../components/shared/SectionWrapper';
import ContentSection from '../../components/shared/ContentSection';

const Eventos = () => {
    // Data for Viaje section
    const viajeContent = [
        "Por primera vez, en febrero de 2025, nuestra cooperativa organizó junto al Campus Castelraimondo, en la región Le Marche, un viaje académico y cultural para aprender no solo el idioma italiano sino también la cultura de este maravilloso país.",
        "Muchas de las clases eran intinerantes y, acompañados por los profesores y guías, visitamos casi 30 ciudades y pueblos diferentes durante dicho mes."
    ];

    const viajeImages = [
        { src: "/images/eventos/VIAJE/V1.png", alt: "Viaje a Italia - Imagen 1" },
        { src: "/images/eventos/VIAJE/V2.png", alt: "Viaje a Italia - Imagen 2" },
        { src: "/images/eventos/VIAJE/V3.png", alt: "Viaje a Italia - Imagen 3" },
        { src: "/images/eventos/VIAJE/V4.png", alt: "Viaje a Italia - Imagen 4" },
        { src: "/images/eventos/VIAJE/V5.png", alt: "Viaje a Italia - Imagen 5" }
    ];

    // Data for Festa section
    const festaContent = [
        "La FESTA CHE CI UNISCE es un evento, respaldado por la Embajada Italiana y por el Municipio, que representa el principal encuentro anual de la colectividad italiana en nuestro país y que tiene lugar una vez al año, en el mes de abril, donde se encuentra la sede de la Asociación Calabresa, en José Enrique Rodó 1969. Esta fiesta, que se lleva a cabo hace cinco años, reúne a la mayoría de las asociaciones italianas del Uruguay y convoca a más de 10.000 personas a lo largo de la jornada.",
        "La presencia activa de la colectividad italiana en Uruguay es testimonio de la importante migración italiana que se produjo en nuestro país. El objetivo es preservar y difundir las tradiciones italianas, brindando la oportunidad de conocerlas."
    ];

    const festaImages = [
        { src: "/images/eventos/FESTA/f1.png", alt: "Festa Che Ci Unisce - Imagen 1" },
        { src: "/images/eventos/FESTA/f2.png", alt: "Festa Che Ci Unisce - Imagen 2" },
        { src: "/images/eventos/FESTA/f3.png", alt: "Festa Che Ci Unisce - Imagen 3" },
        { src: "/images/eventos/FESTA/f4.png", alt: "Festa Che Ci Unisce - Imagen 4" },
        { src: "/images/eventos/FESTA/f5.png", alt: "Festa Che Ci Unisce - Imagen 5" }
    ];

    return (
        <>
            <SEO title="Eventos" />
            <Layout>
                <div className="edu-event-area event-style-1 bg-color-white section-gap-equal">
                    <div className="edu-service-area service-wrapper-3">
                        {/* Viaje Section */}
                        <SectionWrapper title="Viaje Académico y Cultural" additionalClass="pt--60">
                            <ContentSection 
                                textContent={viajeContent}
                                images={viajeImages}
                            />
                        </SectionWrapper>

                        {/* Festa Section */}
                        <SectionWrapper title="Festa Che Ci Unisce" additionalClass="pb--70">
                            <ContentSection 
                                textContent={festaContent}
                                images={festaImages}
                                reverse={true}
                            />
                        </SectionWrapper>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Eventos; 